
import { Component, ViewChild, OnInit, HostListener, ElementRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Business } from '../../../models/register-business';
import { ToastrService } from 'ngx-toastr';
import { ImagePreview } from '../../../models/image-preview-model';
import { KeyTitleModel } from '../../../models/key-value-model';
import { CropperComponent } from 'angular-cropperjs';
import { NgbActiveModal, NgbModal, NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { ImageConfiguration, ImageConfigurationType } from '../../../models/image-configuration';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-image-configuration',
  templateUrl: './image-configuration.component.html',
  styleUrls: ['./image-configuration.component.scss'],
})
export class ImageConfigurationComponent implements OnInit {
  @ViewChild('modalContainer', { static: true }) modalContainer!: ElementRef;
  active: string = "1";
  inputImg: string = '../assets/images/no-image.jpg';
  @ViewChild('angularCropperHome') angularCropperHome!: CropperComponent;
  @ViewChild('angularCropperDetail') angularCropperDetail!: CropperComponent;
  @ViewChild('angularCropperMobile') angularCropperMobile!: CropperComponent;
  lstImageConfigurationDetail: ImageConfiguration[] = [];
  modalHeight: number;
  modalWidth: number;
  homeCropDetail: any;
  detailCropDetail: any;
  mobileCropDetail: any;
  subscribe: Subscription;
  isShow: boolean;
  inverseScale: number;
  imageWidth: number;
  imageHeight: number;
  homeCanvas: any;
  homeCropBox: any;
  detailCanvas: any;
  detailCropBox: any;
  mobileCanvas: any;
  mobileCropBox: any;
  private resizeImageTimer: ReturnType<typeof setTimeout> | null = null;

  configMobile: any = {
    aspectRatio: 340 / 300,
    movable: false,
    zoomable: false,
    scalable: false,
    autoCropArea: 1,
    responsive: true,
    background: false,
    checkCrossOrigin: false,
    checkOrientation: false,
    viewMode: 1,
    minContainerHeight: 300,
  }

  configDetail: any = {
    aspectRatio: 1.45 / 1,
    movable: false,
    zoomable: false,
    scalable: false,
    autoCropArea: 1,
    responsive: true,
    background: false,
    checkCrossOrigin: false,
    checkOrientation: false,
    viewMode: 1,
    minContainerHeight: 300,
  }

  configHome: any = {
    aspectRatio: 3.2 / 1,
    movable: false,
    zoomable: false,
    scalable: false,
    autoCropArea: 1,
    responsive: true,
    background: false,
    checkCrossOrigin: false,
    checkOrientation: false,
    viewMode: 1,
    minContainerHeight: 300,
  }

  constructor(private toastr: ToastrService, private activeModal: NgbActiveModal) {
  }

  ngOnInit() {
    this.adjustModalHeight();
  }

  ngOnDestroy() {
    if (this.resizeImageTimer) {
      clearTimeout(this.resizeImageTimer);
      this.resizeImageTimer = null;
    }
    if (this.subscribe) {
      this.subscribe.unsubscribe();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.adjustModalHeight();
  }

  adjustModalHeight() {
    this.modalHeight = window.innerHeight * 0.60;
    this.modalWidth = window.innerWidth * 0.8;
    if (this.resizeImageTimer) {
      clearTimeout(this.resizeImageTimer);
    }
    if (this.subscribe) {
      this.subscribe.unsubscribe();
    }
    this.resizeImageTimer = setTimeout(() => {
      this.resizeImageTimer = null;
      this.subscribe = this.resizeImage(this.inputImg)
        .subscribe({
          next: (cropped) => {
            this.inputImg = cropped;
            this.isShow = true;
            this.updateActiveCropperConfig();
          },
          error: (err) => {
            console.error('Image crop preview failed:', err);
            this.toastr.error('Could not load this image for cropping. Please try a different photo.');
            this.activeModal.close(null);
          }
        });
    }, 500);
  }

  onDashboardViewCrop(event: any) {
    this.homeCropDetail = event.detail;
  }

  onDetailViewCrop(event: any) {
    this.detailCropDetail = event.detail;
  }

  onMobileViewCrop(event: any) {
    this.mobileCropDetail = event.detail;
  }

  cropImage(active: string) {
    if (active == "1") {
      if (this.homeCropDetail) {
        let dashboardCropDetails = this.lstImageConfigurationDetail.find(p => p.ImageType == ImageConfigurationType.HomePage);
        if (dashboardCropDetails) {
          dashboardCropDetails.X = this.homeCropDetail.x * this.inverseScale;
          dashboardCropDetails.Y = this.homeCropDetail.y * this.inverseScale;
          dashboardCropDetails.Height = this.homeCropDetail.height * this.inverseScale;
          dashboardCropDetails.Width = this.homeCropDetail.width * this.inverseScale;
        } else {
          const homeDetail = {
            ImageId: 0,
            X: this.homeCropDetail.x * this.inverseScale,
            Y: this.homeCropDetail.y * this.inverseScale,
            Height: this.homeCropDetail.height * this.inverseScale,
            Width: this.homeCropDetail.width * this.inverseScale,
            ImageType: ImageConfigurationType.HomePage
          }
          this.lstImageConfigurationDetail.push(homeDetail);
        }

        this.toastr.success("Dashboard View Image Cropped Successfully.");
        this.active = "2";
        this.updateActiveCropperConfig();
        this.resetCropperSetting(this.active);
      }
    }
    else if (active == "2") {
      if (this.detailCropDetail) {
        let detailCropDetails = this.lstImageConfigurationDetail.find(p => p.ImageType == ImageConfigurationType.DetailView);
        if (detailCropDetails) {
          detailCropDetails.X = this.detailCropDetail.x * this.inverseScale;
          detailCropDetails.Y = this.detailCropDetail.y * this.inverseScale;
          detailCropDetails.Height = this.detailCropDetail.height * this.inverseScale;
          detailCropDetails.Width = this.detailCropDetail.width * this.inverseScale;
        } else {
          const detail = {
            ImageId: 0,
            X: this.detailCropDetail.x * this.inverseScale,
            Y: this.detailCropDetail.y * this.inverseScale,
            Height: this.detailCropDetail.height * this.inverseScale,
            Width: this.detailCropDetail.width * this.inverseScale,
            ImageType: ImageConfigurationType.DetailView
          }
          this.lstImageConfigurationDetail.push(detail);
        }

        this.toastr.success("Detail View Image Cropped Successfully.");
        this.active = "3";
        this.updateActiveCropperConfig();
        this.resetCropperSetting(this.active);
      }
    } else if (active == "3") {
      if (this.mobileCropDetail) {
        let mobileCropDetails = this.lstImageConfigurationDetail.find(p => p.ImageType == ImageConfigurationType.MobileView);
        if (mobileCropDetails) {
          mobileCropDetails.X = this.mobileCropDetail.x * this.inverseScale;
          mobileCropDetails.Y = this.mobileCropDetail.y * this.inverseScale;
          mobileCropDetails.Height = this.mobileCropDetail.height * this.inverseScale;
          mobileCropDetails.Width = this.mobileCropDetail.width * this.inverseScale;
        } else {
          const mobileDetail = {
            ImageId: 0,
            X: this.mobileCropDetail.x * this.inverseScale,
            Y: this.mobileCropDetail.y * this.inverseScale,
            Height: this.mobileCropDetail.height * this.inverseScale,
            Width: this.mobileCropDetail.width * this.inverseScale,
            ImageType: ImageConfigurationType.MobileView
          }
          this.lstImageConfigurationDetail.push(mobileDetail);
        }

        this.toastr.success("Mobile View Image Cropped Successfully.");
      }
    }
  }

  resetImage(active: string) {
    if (active == "1") {
      if (this.angularCropperHome) {
        this.angularCropperHome.cropper.reset();
        if (this.lstImageConfigurationDetail.length > 0) {
          let dashboardCropDetails = this.lstImageConfigurationDetail.find(p => p.ImageType == ImageConfigurationType.HomePage);
          if (dashboardCropDetails) {
            const index = this.lstImageConfigurationDetail.indexOf(dashboardCropDetails);
            this.lstImageConfigurationDetail.splice(index, 1);
          }
        }
      }
    }
    else if (active == "2") {
      if (this.angularCropperDetail) {
        this.angularCropperDetail.cropper.reset();
        if (this.lstImageConfigurationDetail.length > 0) {
          let detailCropDetails = this.lstImageConfigurationDetail.find(p => p.ImageType == ImageConfigurationType.DetailView);
          if (detailCropDetails) {
            const index = this.lstImageConfigurationDetail.indexOf(detailCropDetails);
            this.lstImageConfigurationDetail.splice(index, 1);
          }
        }
      }
    } else if (active == "3") {
      if (this.angularCropperMobile) {
        this.angularCropperMobile.cropper.reset();
        if (this.lstImageConfigurationDetail.length > 0) {
          let mobileCropDetails = this.lstImageConfigurationDetail.find(p => p.ImageType == ImageConfigurationType.MobileView);
          if (mobileCropDetails) {
            const index = this.lstImageConfigurationDetail.indexOf(mobileCropDetails);
            this.lstImageConfigurationDetail.splice(index, 1);
          }
        }
      }
    }
  }

  onCloseModal() {
    this.activeModal.close(null);
  }

  onSubmit(active: string) {
    if (!this.lstImageConfigurationDetail.find(p => p.ImageType == ImageConfigurationType.HomePage) || !this.lstImageConfigurationDetail.find(p => p.ImageType == ImageConfigurationType.DetailView) || !this.lstImageConfigurationDetail.find(p => p.ImageType == ImageConfigurationType.MobileView)) {
      if (this.angularCropperHome) {
        this.homeCropBox = this.angularCropperHome.cropper.getData();
        this.homeCanvas = this.angularCropperHome.cropper.getCanvasData();
      }
      if (this.angularCropperDetail) {
        this.detailCropBox = this.angularCropperDetail.cropper.getData();
        this.detailCanvas = this.angularCropperDetail.cropper.getCanvasData();
      }
      if (this.angularCropperMobile) {
        this.mobileCropBox = this.angularCropperMobile.cropper.getData();
        this.mobileCanvas = this.angularCropperMobile.cropper.getCanvasData();
      }
      this.cropImage(active);
      if (active == "3") {
        this.activeModal.close(this.lstImageConfigurationDetail);
      }
    }
  }

  beforeTabChange = (event: NgbNavChangeEvent) => {
    if (event && (event.activeId == "1" && event.nextId == "3" && !this.lstImageConfigurationDetail.find(p => p.ImageType == ImageConfigurationType.HomePage)
      && !this.lstImageConfigurationDetail.find(p => p.ImageType == ImageConfigurationType.DetailView))) {
      event.preventDefault();
      this.toastr.error("Please complete all the section's crop settings before moving to last!");
      return;
    }
    if (Number(event.nextId) > Number(event.activeId)) {
      this.cropImage(event.activeId);
    }
    if (this.angularCropperHome) {
      this.homeCropBox = this.angularCropperHome.cropper.getData();
      this.homeCanvas = this.angularCropperHome.cropper.getCanvasData();
    }
    if (this.angularCropperDetail) {
      this.detailCropBox = this.angularCropperDetail.cropper.getData();
      this.detailCanvas = this.angularCropperDetail.cropper.getCanvasData();
    }
    if (this.angularCropperMobile) {
      this.mobileCropBox = this.angularCropperMobile.cropper.getData();
      this.mobileCanvas = this.angularCropperMobile.cropper.getCanvasData();
    }
    this.updateActiveCropperConfig();
    this.resetCropperSetting(event.nextId);
  }

  resetCropperSetting = (nextId: string) => {
    if (nextId == "1" && this.homeCropBox) {
      setTimeout(() => {
        this.angularCropperHome.cropper.setData(this.homeCropBox);
        if (this.homeCanvas) {
          this.angularCropperHome.cropper.setCanvasData(this.homeCanvas);
        }
      }, 100);
    }
    if (nextId == "2" && this.detailCropBox) {
      setTimeout(() => {
        this.angularCropperDetail.cropper.setData(this.detailCropBox);
        if (this.detailCanvas) {
          this.angularCropperDetail.cropper.setCanvasData(this.detailCanvas);
        }
      }, 100);
    }
    if (nextId == "3" && this.mobileCropBox) {
      setTimeout(() => {
        this.angularCropperMobile.cropper.setData(this.mobileCropBox);
        if (this.mobileCanvas) {
          this.angularCropperMobile.cropper.setCanvasData(this.mobileCanvas);
        }
      }, 100);
    }
  }

  updateActiveCropperConfig = () => {
    if (this.active == "1") {
      this.configHome = {
        ...this.configHome,
        minContainerHeight: this.imageHeight,
        minContainerWidth: this.imageWidth
      };
    } else if (this.active == "2") {
      this.configDetail = {
        ...this.configDetail,
        minContainerHeight: this.imageHeight,
        minContainerWidth: this.imageWidth
      };
    } else if (this.active == "3") {
      this.configMobile = {
        ...this.configMobile,
        minContainerHeight: this.imageHeight,
        minContainerWidth: this.imageWidth
      };
    }
  }

  resizeImage(imageSrc: string): Observable<string> {
    return new Observable(observer => {
      const img = new Image();
      const isRemote = /^https?:\/\//i.test(imageSrc) && imageSrc.indexOf(window.location.origin) !== 0;
      if (isRemote) {
        img.crossOrigin = 'anonymous';
      }

      img.onload = () => {
        try {
          let width = img.naturalWidth || img.width;
          let height = img.naturalHeight || img.height;
          this.inverseScale = 1;

          if (!width || !height) {
            observer.error('invalid-image-size');
            return;
          }

          const modalRect = this.modalContainer?.nativeElement?.getBoundingClientRect();
          const modalW = (modalRect && modalRect.width > 50) ? modalRect.width : (window.innerWidth * 0.8) || 320;
          const modalH = this.modalHeight > 50 ? this.modalHeight : (window.innerHeight * 0.6) || 320;

          if (width > modalW || height > modalH) {
            const maxWidth = Math.max(1, modalW - 50);
            const maxHeight = Math.max(1, modalH - 50);
            const scale = Math.min(maxWidth / width, maxHeight / height);
            this.inverseScale = Math.max(width / maxWidth, height / maxHeight);
            width = Math.max(1, Math.floor(width * scale));
            height = Math.max(1, Math.floor(height * scale));
          }

          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          if (!ctx) {
            observer.error('no-2d-context');
            return;
          }
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);

          this.imageWidth = width;
          this.imageHeight = height;
          this.inputImg = canvas.toDataURL('image/jpeg', 0.9);

          canvas.width = 0;
          canvas.height = 0;

          observer.next(this.inputImg);
          observer.complete();
        } catch (err) {
          observer.error(err);
        }
      };

      img.onerror = () => observer.error('image-load-failed');
      img.src = imageSrc;
    });
  }
}
